type ArrayMember = string | number;
export const convertPrimitiveArrayToDictionary = (array: ArrayMember[]): Record<ArrayMember, boolean> => {
	return array.reduce<Record<ArrayMember, boolean>>((acc, item) => {
		acc[item] = true;
		return acc;
	}, {});
};
